<template>
  <div>
     <b-row>
      <b-col md="12">
        <eb-select label="name" @input="getCountry" :options="countries" placeholder="Country"></eb-select>
      </b-col>
    </b-row>
    <b-row class="statemargintop">
      <b-col md="6">
        <eb-select label="name" @input="getState" :options="states" placeholder="State"></eb-select>
      </b-col>
      <b-col md="6">
        <eb-select placeholder="City" :options="cities" label="name" @input="getCity"></eb-select>
      </b-col>
    </b-row>
    <div class="streetmargintop">
      <c-input
        type
        inputId="street"
        lableText="Street Line 1"
        class="mt-3"
        v-model="office.address.street1"
      />

      <c-input
        inputType="text"
        inputId="address"
        lableText="Street Line 2"
        class="mt-3"
        v-model="office.address.street2"
      />
    </div>
    <b-row class="mt-2">
      <b-col md="12">
        <c-input
          type="text"
          inputId="hno"
          v-model="office.address.houseNumber"
          lableText="House Number"
        />
      </b-col>
    </b-row>
      <b-row>
      <b-col md="12">
        <c-input inputType="number" inputId="zipcode" v-model="office.address.zip" lableText="Zipcode" />
      </b-col>
    </b-row>
    <slot name="footer-button" :data="office">
      <b-button
        class="btn btn-block mt-3"
        btn-color="primary"
        @click="e=>$emit('onClickOffice',office)"
      >Next</b-button>
    </slot>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import csc from "country-state-city";
import ebSelect from "@/components/FormElements/Select";

export default {
  name: "OfficeStepper",

  data() {
    return {
      countries: [],
      states: [],
      cities: [],
      tenant: null,
      office: {
        address: {
          country: "",
          state: "",
          city: "",
          street1: "",
          location: {
            coordinates: [0, 0]
          },
          street2: "",
          zip: "",
          houseNumber: ""
        }
      }
    };
  },
  components: {
    cInput,
    cTelInput,
    ebSelect
  },
  methods: {
    isValidate(e, p) {
      p.country = { ...e.country };
      p.isValid = e.isValid;
    },
    getCountry(payload) {
      this.setState(payload.id);
      this.office.address.country = payload.name;
    },
    getState(payload) {
      this.setCity(payload.id);
      this.office.address.state = payload.name;
    },
    getCity(payload) {
      this.office.address.city = payload.name;
    },
    async setCountry() {
      this.countries = await csc.getAllCountries();
    },
    async setState(id) {
      this.states = await csc.getStatesOfCountry(id);
    },
    async setCity(id) {
      this.cities = await csc.getCitiesOfState(id);
    }
  },
  mounted() {
    this.setCountry();
  }
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 39px;
  width: 132px;
  background-color: #727cf5;
  color: white;
}
.statemargintop {
  margin-top: -15px !important;
}
.streetmargintop {
  margin-top: -8px !important;
}
</style>
<style>
.vue-tel-input {
  border-radius: 0px !important;
  height: 39px !important;
  border: 1px solid #dee2e6 !important;
}
</style>
